export default __webpack_public_path__ + "static/media/image_watermark.88b84a86.svg";